import { render } from "./FooterAnth.vue?vue&type=template&id=3e4109e5"
import script from "./FooterAnth.js?vue&type=script&lang=js&external"
export * from "./FooterAnth.js?vue&type=script&lang=js&external"

import "./FooterAnth.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__